import type { PortfolioReport } from '@interfaces/portfolioReport';

export const buildReportTickerMap = (
  reports: PortfolioReport[],
): Record<string, string> => {
  const map: Record<string, string> = {};

  for (const report of reports) {
    for (const holding of report.holdings ?? []) {
      const financialProduct = holding.financialProduct;
      if (financialProduct?.id && financialProduct.ticker) {
        map[financialProduct.id] = financialProduct.ticker;
      }
    }
  }

  return map;
};
